import * as State from 'components/desktop/ShoppingCart/Detail/State';
import { useHandler } from 'hooks/useHandler';

export default function useState(editMode?: boolean) {
	const [state, rf] = useHandler<State.Type>(State.create(editMode));
	return {
		state,
		handlers: {
			setSearchProducts: rf.createReducer(State.setSearchProducts),
			setSearchSources: rf.createReducer(State.setSearchSources),
			toggleEditMode: rf.createReducer(State.toggleEditMode),
			toggleShowReceipt: rf.createReducer(State.toggleShowReceipt),
		},
	};
}

export type ShoppingCartDetailHandlers = ReturnType<typeof useState>['handlers'];
